export enum CategoryType {
    General = 'GENERAL',
    Help = 'HELP',
    Diversity = 'DIVERSITY',
    Attitude = 'ATTITUDE',
    Conversation = 'CONVERSATION',
}
